import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useCloseModal } from '../../components/modals/ModalsContext'
import { useOpenEditActionPlanModal } from '../../utils/routes/modals/modalsActions'
import ActionPlansList from './ActionPlansList'
import Separator from '../../components/helpers/Separator'
import Panel from '../../packages/kiti/components/structure/Panel'
import IconText from '../../packages/kiti/components/presentation/IconText'

const ActionPlansInput = ({ value = [], onChange, placeId }) => {
  const { t } = useTranslation('actionPlans')
  const openEditActionPlanModal = useOpenEditActionPlanModal()
  const closeModal = useCloseModal()
  const handleSubmit = actionPlan => {
    onChange([...value, actionPlan])
    closeModal()
  }

  return (
    <div>
      <ActionPlansList hideLabel items={value} onRemove={(_, index) => onChange(value.filter((_, i) => i !== index))} />
      <Separator weight={2} />
      <Panel
        padding={0.6}
        borderColor={COLORS.light5}
        onClick={() => openEditActionPlanModal({ placeId, onSubmit: handleSubmit })}
      >
        <IconText
          justify="center"
          label={t('addActionPlan')}
          color={COLORS.dark4}
          iconLeft="BsPlusCircle"
          iconSize={1}
        />
      </Panel>
    </div>
  )
}

export default ActionPlansInput
